import { DataServiceModule } from './data.service';

export const StoreAddressesModule = angular
    .module('app.services.data.storeAddresses', [
        DataServiceModule
    ]).service('storeAddressesService', (
        $q,
        dataService,
        settings
    ) => {
        return {
            getAddresses,
            getPrimaryAddress,
            updatePrimaryAddress,
            hasPrimaryStoreAddress,
            add,
            save
        };

        function add(address) {
            return dataService.create(settings.api.storeAddress, {
                address: address
            });
        }

        function getAddresses() {
            return dataService.get(settings.api.storeAddresses);
        }
        function getPrimaryAddress() {
            return dataService.get(settings.api.storeAddressesPrimary)
                .then((primaryAddress) => {
                    if (!primaryAddress || !primaryAddress.mailingAddress) {
                        return $q.reject({});
                    }
                    return primaryAddress;
                });
        }
        function updatePrimaryAddress(address) {
            if (!address.isPrimary) {
                address.isPrimary = true;
            }
            return dataService.create(settings.api.storeAddressesPrimary, {
                address
            });
        }
        function save(data) {
            return dataService.create(settings.api.storeAddresses, {
                storeAddresses: data
            });
        }
        function hasPrimaryStoreAddress() {
            return dataService.get(settings.api.storeAddressesPrimary)
                .then((primaryAddress) => {
                    return (primaryAddress && primaryAddress.mailingAddress);
                }).catch(() => {
                    return false;
                });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/storeAddresses.service.js